import { useCallback } from 'react'
import type { DecorationType } from 'src/services/apollo/generated/graphql'
import { type UserBaseFragment } from 'src/services/apollo/generated/graphql'
import {
  useMyActiveDecorations,
  useToggleActiveDecoration,
} from '~/services/orpc/decoration'

export function getUserActiveDecoration(
  user: Pick<UserBaseFragment, 'activeDecorations'> | undefined,
  opts: {
    type: DecorationType
  },
) {
  return user?.activeDecorations?.find(it => it.decoration.type === opts.type)
}

export function useToggleMyActiveDecoration(opts: {
  type: DecorationType
  target: boolean
}) {
  const { data: decorations } = useMyActiveDecorations()
  const activeDecoration = decorations?.find(
    it => it.decoration.type === opts.type,
  )
  const [toggleDecoration] = useToggleActiveDecoration()
  const fn = useCallback(async () => {
    if (activeDecoration) {
      await toggleDecoration({
        variables: {
          decorationId: activeDecoration.decoration.id,
          enabled: opts.target,
        },
      })
    }
  }, [activeDecoration, opts.target, toggleDecoration])

  return fn
}
